module.exports = __webpack_public_path__ + "img/team-leader.45278f1b.png";